import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { Popup } from '../../../../ui/popup/popup';
import { getReturnURL } from '../../../../domain/url-provider';
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";

/**
 * Login popup component.
 * Use in 'products I have' widget.
 */
export const ProductsIOwnLoginPopup = () => {

    const dispatch = useAppDispatch();
    const showLoginPage = useAppSelector(store => store.showLoginPage);

    return (
        showLoginPage ? (
            <Popup width="400px" height="270px" close={ () => {
                dispatch(
                    rootActions.main({
                        showLoginPage: false
                    })
                );
                sendGAEvent('JPList', `Products I Have: Login Popup Close`);
            }}>
                <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">
                    <p className="mb-4">Please log in to your Waves account to hide products you own.</p>
                    <a className="w-btn" href={ getReturnURL() } title="LOG IN NOW" style={{ width: '170px' }}>LOG IN NOW</a>
                </div>
            </Popup>
        ): <></>
    )
};